// extracted by mini-css-extract-plugin
export default {"aboutContainer":"homeAboutMe_aboutContainer__67H5A","myImage":"homeAboutMe_myImage__f89TB","text":"homeAboutMe_text__vgx2Z"};